import HelpButton from 'components/help/HelpButton'
import React from 'react'

function HelpTitle({title, subtitle, helpSubject}) {

  return (
    <div className='flex flex-col w-full'>
      <div className='w-full flex flex-row justify-between mb-4'>
        <div className='w-12'></div>
        <div className='text-xl small:text-2xl phone:text-3xl font-bold'>
            {title}
        </div>
        <div className='w-12'>
          <HelpButton helpType={helpSubject} />
        </div>
      </div>
      {subtitle &&
        <div className='w-full flex justify-center text-lg font-bold mb-4'>
            {subtitle}
        </div>
      }
    </div>
  )
}

export default HelpTitle